import { render, staticRenderFns } from "./markRuleDetailModal.vue?vue&type=template&id=1ca7e381&scoped=true"
import script from "./markRuleDetailModal.vue?vue&type=script&lang=js"
export * from "./markRuleDetailModal.vue?vue&type=script&lang=js"
import style0 from "./markRuleDetailModal.vue?vue&type=style&index=0&id=1ca7e381&prod&scoped=true&lang=less"
import style1 from "./markRuleDetailModal.vue?vue&type=style&index=1&id=1ca7e381&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7e381",
  null
  
)

export default component.exports